<template>
    <div class="wrapper-common">
      <company-header></company-header>
      <slot></slot>
      <div class="common-content">
          <slot name="content"></slot>
      </div>
      <company-footer></company-footer>
    </div>
</template>
<script>
import CompanyHeader from './com/company-header.vue'
import CompanyFooter from './com/company-footer.vue'
export default {
  components: {
    CompanyHeader,
    CompanyFooter
  }
}
</script>
<style lang="scss" scoped>
.wrapper-common{
  background: #f7f7f7;
}
/deep/ .company-header,.company-footer{
  width: 100%;
  background: #2D334B;
}
</style>
